export enum CodeCesu {
    ADD_CESU = "ADD_CESU",
    HAS_CESU = "HAS_CESU",
    WITHOUT_CESU = "WITHOUT_CESU",
}

export interface CesuCheckResponse {
    inscrit?: boolean;
    mandatPresent?: boolean;
    etatCesuPlus?: string;
    etatAICI?: unknown;
}
